import { useCreateDeviceMutation } from '@/graphql/types';

export default function (device: {
  name?: string | undefined;
  stationNumber?: string | undefined;
  templateId: string;
  deviceId: string;
  organisationId: string;
}) {
  const mutation = useCreateDeviceMutation({});

  function call() {
    return mutation.mutate({
      input: {
        name: device.name,
        templateId: device.templateId,
        stationNumber: device.stationNumber,
        deviceId: device.deviceId,
        organisationId: device.organisationId
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
